import * as React from 'react'
import { useParams } from 'react-router-dom'
import DriverViewControlBarLayout from './DriverViewControlBarLayout'

import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import useChangeDriverParams from '../../hooks/useChangeDriverParams'
import { useQueryDriver } from '@/lib/api/company/drivers'

const DriverViewControlBarClear = () => {
  const { companyId, driverId } = useParams<{
    companyId: string
    driverId: string
  }>()
  const { driversIds } = useDrivers()
  const { goNextDriverInActivity, goPrevDriverInActivity } =
    useChangeDriverParams()
  const { data: driver } = useQueryDriver({
    companyId,
    driverId,
    withPersonalData: true,
  })

  const sortedIds = [...driversIds].sort((a: number, b: number) => a - b)
  const numericId = Number(driverId)

  return (
    <DriverViewControlBarLayout
      companyId={companyId}
      fullName={driver?.fullName}
      onPrev={() => goPrevDriverInActivity({ sortedIds, numericId })}
      onNext={() => goNextDriverInActivity({ sortedIds, numericId })}
    />
  )
}

export default DriverViewControlBarClear
